var WarningLevel;
(function (WarningLevel) {
    WarningLevel["Warning"] = "warning";
    WarningLevel["Error"] = "error";
})(WarningLevel || (WarningLevel = {}));
const isRefCallback = (ref) => {
    return typeof ref === 'function';
};

export { WarningLevel, isRefCallback };
//# sourceMappingURL=types.js.map
